import script from "./Disciplines.vue?vue&type=script&setup=true&lang=ts"
export * from "./Disciplines.vue?vue&type=script&setup=true&lang=ts"

import "./Disciplines.vue?vue&type=style&index=0&id=27119c3b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27119c3b"]])

export default __exports__